import { MenuItem } from "@/hooks/useMenu";
import { cn } from "@/lib/utils";
import { useCartStore } from "@/store/CartStore";
import { UpsaleItem } from "./UpsaleItem";

export function UpsaleList({
  className = "",
  products = [],
}: {
  className?: string;
  products: MenuItem[];
}) {
  const { cart } = useCartStore();

  const productsFiltered = products
    .filter((product) => product.can_purchase !== false) // Filter out counter-only items
    .sort((a, b) => {
      if (a.unavailable && !b.unavailable) return 1;
      if (!a.unavailable && b.unavailable) return -1;
      return 0;
    });

  return (
    <div
      className={cn(
        "z-[1] grid grid-cols-1 md:gap-4 max-md:divide-y max-md:divide-border",
        className
      )}
    >
      {productsFiltered.map((item) => {
        const itemsInCart = cart.filter(
          (cartItem) => cartItem.productId === item.id
        );

        if (itemsInCart.length > 0) {
          return itemsInCart.map((cartItem) => {
            return (
              <div
                key={cartItem.lineId}
                className="flex flex-col gap-y-0 h-full relative"
              >
                <UpsaleItem item={item as MenuItem} cartItem={cartItem} />
              </div>
            );
          });
        }

        return (
          <div
            key={item.id}
            className="flex flex-col gap-y-0 md:border-t first:border-none [&:nth-child(2)]:border-none h-full"
          >
            <UpsaleItem item={item as MenuItem} />
          </div>
        );
      })}
    </div>
  );
}
